import { render, staticRenderFns } from "./MedalsPage.vue?vue&type=template&id=2231ccce&scoped=true"
import script from "./MedalsPage.vue?vue&type=script&lang=js"
export * from "./MedalsPage.vue?vue&type=script&lang=js"
import style0 from "./MedalsPage.vue?vue&type=style&index=0&id=2231ccce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2231ccce",
  null
  
)

export default component.exports